<script>
  export default {
    name: 'RequiredLabel',

    props: {
      isHorizontal: {
        type: Boolean,
        default: false,
      },
      label: {
        type: String,
        default: '',
      },
      required: {
        type: Boolean,
        default: false,
      },
      comment: {
        type: String,
        default: '',
      },
    },
  }
</script>

<template>
  <label :class="{ '--horizontal': isHorizontal }">
    <span>
      {{ label }}
      <span
        v-if="required"
        class="required"
      >*</span>
    </span>
    <span
      v-if="comment"
      class="comment"
    >{{ comment }}</span>
  </label>
</template>

<style lang="stylus" scoped>
label
  flex-shrink 0
  margin-bottom 0
  font-weight normal

.required
  margin-left 4px
  color #ff525d

.comment
  font-size 12px
  color #c4cdd6

&.--horizontal
  display flex
  flex-direction column
</style>
